import jQuery from 'jquery';
let $ = jQuery;
import 'HSNDIR/Widget/ComboBox';

/**
    * class HSN.Widget.SwatchBox
    *
    * Handles the swatch widgets in ProductCardGrid views
**/

HSN.Widget.SwatchBox = function () {
    var selector;
    var replaceImage;
    var replaceText;
    var itemSelector = 'li[role="option"]';
    var comboBoxes = [];
    var deviceInfo = HSN.Instance().DeviceInformation;
    var isMobile = deviceInfo.IsMobile && !deviceInfo.IsTablet;
    var application = HSN.Instance();

    /**
        * new HSN.Widget.SwatchBox.init(config)
        * @param {object} config: A configuration object for the [[HSN.Widget.SwatchBox]]
        *   consisting of the following keys:
        *   - selector (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will
        *     resolve to 0 or more HTML elements that will act as the root containers for the widgets.
        *   - replaceImage (bool): An optional flag to replace the .image html instead of update the <img> src
        *   - replaceText (bool): An optional flag to replace the text inside .more-swatches when swatch selected
    **/
    var init = function(config) {
        selector = config.selector;
        replaceImage = config.replaceImage ? true : false;
        replaceText = config.replaceText ? true : false;

        $(selector).each((i, el) => {
            var container = $(el);

            if (container.data('swatchbox-initialized') === true) {
                return true;
            } else {
                container.data('swatchbox-initialized', true);
            }

            var button = container.find('.swatchbox-button');
            var flyout = container.find('.swatchbox-flyout');
            var item = container.closest('.product-item');
            var combobox = new HSN.Widget.ComboBox();

            combobox.init({
                application: HSN.Instance(),
                container: container,
                button: button,
                flyout: flyout,
                triggerType: combobox.triggerTypes.button,
                flyoutType: combobox.flyoutTypes.listbox,
                flyoutItemSelector: itemSelector
            });

            var open = function() {
                $.each(comboBoxes, function(i, box) {
                    box.hideFlyout();
                });

                combobox.showFlyout(true);

                HSN.ScrollToElement(item, 200, isMobile ? 40 : 0);
            };

            var selected = function() {
                var selectedItem = combobox.getFocusedItem();
                var image = item.find('.image img');
                var src = selectedItem.data('main-image');

                if (replaceImage) {
                    image.closest('.image').html($(`<img src=${src}>`));
                }
                else {
                    image.attr('src', src);
                }
                if (replaceText) {
                    var text = selectedItem.find('.name').text();
                    container.find('.more-swatches').text(text);
                }

                combobox.hideFlyout();
                button.focus();

                application.Events.Trigger(HSN.Widget.SwatchBox.EVENTS.ITEM_SELECTED, image.closest('.image'));
            };

            var itemClick = function(e) {
                var target = $(e.currentTarget);
                combobox.selectItem(target);
                e.stopPropagation();
            };

            combobox.events.On(HSN.Widget.ComboBox.EVENT.EXECUTE, open);
            combobox.events.On(HSN.Widget.ComboBox.EVENT.ITEMSELECTED, selected);
            flyout.on('click', itemSelector, itemClick);

            comboBoxes.push(combobox);
        });
    };

    return {
        init: init
    };
};

HSN.Widget.SwatchBox.EVENTS = {
    ITEM_SELECTED: 'HSN.Widget.SwatchBox.EVENTS.ITEM_SELECTED'
}


// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/SwatchBox.js